import React from 'react';
import Views from '.';
import SubMenu from './sub-menu/sub-menu';

const SubMenuView = ({title, ...props}) => {
  return (
    <Views title={title}>
      <SubMenu {...props} />
    </Views>
  );
};

export default SubMenuView;
